export default __webpack_public_path__ + "static/media/3-1.88deb473.jpg";